import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'https://misgolpes-backend-production.up.railway.app';

class SocketService {
  constructor() {
    this.socket = null;
  }

  connect() {
    if (!this.socket) {
      this.socket = io(SOCKET_URL, {
        transports: ['websocket', 'polling'], // Permitir fallback a polling
        autoConnect: true,
        reconnection: true,
        reconnectionDelay: 1000,
        reconnectionAttempts: 5,
        timeout: 20000
      });

      this.socket.on('connect', () => {
        console.log('✅ Conectado a Socket.IO con', this.socket.io.engine.transport.name);
      });

      this.socket.on('disconnect', (reason) => {
        console.log('❌ Desconectado de Socket.IO:', reason);
      });

      this.socket.on('connect_error', (error) => {
        console.error('❌ Error de conexión Socket.IO:', error.message);
      });

      this.socket.on('reconnect', (attemptNumber) => {
        console.log('🔄 Reconectado a Socket.IO después de', attemptNumber, 'intentos');
      });
    }
    return this.socket;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  joinPartida(codigo) {
    if (this.socket) {
      this.socket.emit('join-partida', codigo);
    }
  }

  actualizarGolpe(codigo, jugadorId, hoyoNumero, golpes) {
    if (this.socket) {
      this.socket.emit('actualizar-golpe', { codigo, jugadorId, hoyoNumero, golpes });
    }
  }

  registrarDrop(codigo, jugadorId, hoyoNumero) {
    if (this.socket) {
      this.socket.emit('registrar-drop', { codigo, jugadorId, hoyoNumero });
    }
  }

  registrarMulligan(codigo, jugadorId, hoyoNumero) {
    if (this.socket) {
      this.socket.emit('registrar-mulligan', { codigo, jugadorId, hoyoNumero });
    }
  }

  cambiarHoyo(codigo, jugadorId, hoyoNumero) {
    if (this.socket) {
      this.socket.emit('cambiar-hoyo', { codigo, jugadorId, hoyoNumero });
    }
  }

  actualizarRanking(codigo, ranking) {
    if (this.socket) {
      this.socket.emit('actualizar-ranking', { codigo, ranking });
    }
  }

  iniciarPartida(codigo) {
    if (this.socket) {
      this.socket.emit('iniciar-partida', codigo);
    }
  }

  finalizarPartida(codigo, estadisticas) {
    if (this.socket) {
      this.socket.emit('finalizar-partida', { codigo, estadisticas });
    }
  }

  nuevoJugador(codigo, jugador) {
    if (this.socket) {
      this.socket.emit('nuevo-jugador', { codigo, jugador });
    }
  }

  on(event, callback) {
    if (this.socket) {
      this.socket.on(event, callback);
    }
  }

  off(event, callback) {
    if (this.socket) {
      this.socket.off(event, callback);
    }
  }
}

const socketService = new SocketService();
export default socketService;
